<template>
<div class="rn-contact-address-area rn-section-gap bg_color--5">
    <v-container>
        <v-row class="mt_dec--40">
            <!-- Start Single Address  -->
            <v-col lg="6" md="6" sm="6" cols="12" class="mt--40" v-if="NOTARIA.Contacto.Telefono || NOTARIA.Contacto.Fax || NOTARIA.Contacto.Movil">
            <div class="rn-address card-contacto-notin" :class="{ 'no-icon': !showIcons }">
                <div class="icon" v-if="showIcons">
                    <v-icon>mdi-phone</v-icon>
                </div>
                <div class="inner" >
                    <h3>{{$t('telefono')}}</h3>
                    <p v-if="NOTARIA.Contacto.Telefono || NOTARIA.Contacto.Movil">
                        <a v-if="NOTARIA.Contacto.Telefono" aria-label="teléfono de la notaría" :href="'tel:'+NOTARIA.Contacto.Telefono">{{NOTARIA.Contacto.Telefono}}</a>
                        <span v-if="NOTARIA.Contacto.Telefono && NOTARIA.Contacto.Movil"> | </span>
                        <a v-if="NOTARIA.Contacto.Movil" :href="'tel:'+NOTARIA.Contacto.Movil">{{NOTARIA.Contacto.Movil}}</a>
                    </p>
                    <p v-if="NOTARIA.Contacto.Fax">
                        <a :href="'tel:'+NOTARIA.Contacto.Fax">{{NOTARIA.Contacto.Fax}} (Fax)</a>
                    </p>
                </div>
            </div>
            </v-col>
            <!-- End Single Address  -->

            <!-- Start Single Address  -->
            <v-col lg="6" md="6" sm="6" cols="12" class="mt--40" v-if="NOTARIA.Contacto.Email">
            <div class="rn-address card-contacto-notin" :class="{ 'no-icon': !showIcons }">
                <div class="icon" v-if="showIcons">
                    <v-icon>mdi-mail</v-icon>
                </div>
                <div class="inner">
                    <h3>{{$t('email')}}</h3>
                    <p v-if="NOTARIA.Contacto.Email">
                        <a :href="'mailto:'+NOTARIA.Contacto.Email">{{NOTARIA.Contacto.Email}}</a>
                    </p>
                    <p v-if="NOTARIA.Contacto.Email2">
                        <a :href="'mailto:'+NOTARIA.Contacto.Email2">{{NOTARIA.Contacto.Email2}}</a>
                    </p>
                </div>
            </div>
            </v-col>
            <!-- End Single Address  -->

            <!-- Start Single Address  -->
            <v-col lg="6" md="6" sm="6" cols="12" class="mt--40">
            <div class="rn-address card-contacto-notin" :class="{ 'no-icon': !showIcons }">
                <div class="icon" v-if="showIcons">
                    <v-icon>mdi-map-marker</v-icon>
                </div>
                <div class="inner">
                    <h3>{{$t('localizacion')}}</h3>
                    <p>
                        <a :href="NOTARIA.Contacto.EnlaceMaps" target="_blank">
                            {{NOTARIA.Contacto.Direccion}}<br>
                            {{NOTARIA.Contacto.CP}}, {{NOTARIA.Contacto.Municipio}}, {{NOTARIA.Contacto.Provincia}}
                        </a>
                    </p>
                </div>
            </div>
            </v-col>
            <!-- End Single Address  -->

            <!-- Start Single Address (Accesos) -->
            <v-col lg="6" md="6" sm="6" cols="12" class="mt--40" v-if="NOTARIA.Contacto.Parking">
            <div class="rn-address card-contacto-notin" :class="{ 'no-icon': !showIcons }">
                <div class="icon icon-tajeta" v-if="showIcons">
                    <v-icon>mdi-bus</v-icon>
                </div>
                <div class="inner">
                    <h3>{{$t('accesos')}}</h3>
                    <p v-html="NOTARIA.Contacto.Parking.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                </div>
            </div>
            </v-col>
            <!-- End Single Address  -->

            <!-- Start Single Address (Parking) -->
            <v-col lg="6" md="6" sm="6" cols="12" class="mt--40" v-if="NOTARIA.Contacto.Accesos">
            <div class="rn-address card-contacto-notin" :class="{ 'no-icon': !showIcons }">
                <div class="icon icon-tajeta" v-if="showIcons">
                    <v-icon>mdi-car</v-icon>
                </div>
                <div class="inner">
                    <h3>Parking</h3>
                    <p v-html="NOTARIA.Contacto.Accesos.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                </div>
            </div>
            </v-col>
            <!-- End Single Address  -->
        </v-row>
    </v-container>
</div>
</template>
<script setup lang="ts">
import { useStore } from '../../store/index'
const store = useStore()
const {NOTARIA} = storeToRefs(store)
import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()

import { useStyles } from '../../store/styles';
const style = useStyles();


const showIcons = computed(() => {
  return NOTARIA.value?.Theme?.Contacto?.ShowIcons !== false;
})

const estiloTarjetaTituloColor = style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Color
const estiloTarjetaTituloShadow = style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionContacto.Tarjeta.Titulo.css.BackgroundColor:""
const estiloTarjetaTituloFont = style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Font
const estiloTarjetaTituloSize = style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Size
const estiloTarjetaTituloWeight = style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Weight
const estiloTarjetaTituloAlign = style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Align

const estiloTarjetaDescripcionColor = style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Color
const estiloTarjetaDescripcionShadow = style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionContacto.Tarjeta.Descripcion.css.BackgroundColor:""
const estiloTarjetaDescripcionFont = style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Font
const estiloTarjetaDescripcionWeight = style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Weight
const estiloTarjetaDescripcionSize = style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Size
const estiloTarjetaDescripcionAlign = style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Align
</script>

<style lang="scss">
  .card-contacto-notin h3{
    color:v-bind(estiloTarjetaTituloColor)  !important;
    text-shadow:v-bind(estiloTarjetaTituloShadow)  !important;
    font-size:v-bind(estiloTarjetaTituloSize) !important;
    font-family: v-bind(estiloTarjetaTituloFont) !important;
    font-weight:v-bind(estiloTarjetaTituloWeight) !important;
    text-align:v-bind(estiloTarjetaTituloAlign)  !important;
  }

  .card-contacto-notin .inner p, .card-contacto-notin .inner a{
    color:v-bind(estiloTarjetaDescripcionColor)  !important;
    text-shadow:v-bind(estiloTarjetaDescripcionShadow)  !important;
    font-family:v-bind(estiloTarjetaDescripcionFont)  !important;
    font-size: v-bind(estiloTarjetaDescripcionSize) !important;
    font-weight:v-bind(estiloTarjetaDescripcionWeight) !important;
    text-align:v-bind(estiloTarjetaDescripcionAlign)  !important;
  }
  
    .card-contacto-notin .icon:hover{
        background:v-bind(estiloTarjetaTituloColor) !important;
        border-color:v-bind(estiloTarjetaTituloColor) !important;
    }
    .card-contacto-notin:hover .icon{
    background:v-bind(estiloTarjetaTituloColor) !important;
    border-color:v-bind(estiloTarjetaTituloColor) !important;
    }
    .rn-address.no-icon {
        padding-top: 40px !important;
    }
</style>
